var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 55,
    viewBox: "0 0 39 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.402 52.836C13.074 43.344 2 30.476 2 19.402 2 9.807 9.807 2 19.402 2c9.596 0 17.403 7.807 17.403 17.402 0 11.075-11.075 23.942-17.403 33.434z",
    fill: "#fff",
    stroke: "#485695",
    strokeWidth: 2.813,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.402 27.313c-4.361 0-7.91-3.55-7.91-7.91 0-4.362 3.549-7.91 7.91-7.91 4.362 0 7.91 3.548 7.91 7.91 0 4.36-3.548 7.91-7.91 7.91z",
    fill: "#485695",
    stroke: "#485695",
    strokeWidth: 2.813,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMapMarker;